export default {
  setCurrency: (state, store, code) => {
    state.currency.code = code

    //Save it
    localStorage.setItem('currency', code)
    // store.currency_code = code;
  },
}
